'use client'

import { createContext, useContext, useState } from 'react'
import { useFeatureFlags } from './FeatureFlagsProvider'
type EasterEggContextType = {
  triggerSnowyRun: () => void
  snowyRun: boolean
  isChristmas: boolean
  isHalloween: boolean
  isThanksgiving: boolean
  isValentine: boolean
  isCNY: boolean
  isPride: boolean
  isAprilFools: boolean
  aprilFoolsActive: boolean
  triggerAprilFools: () => void
  resetAprilFools: () => void
  isBasketball: boolean
  isBirthday: boolean
  basketballActive: boolean
  triggerBasketball: () => void
  resetBasketball: () => void
}

const EasterEggContext = createContext<EasterEggContextType | null>(null)

export const useEasterEggs = () => {
  const context = useContext(EasterEggContext)
  if (!context) throw new Error('useSnowy must be used within SnowyProvider')
  return context
}

export const EasterEggProvider = ({ children }: { children: React.ReactNode }) => {
  const [snowyRun, setSnowyRun] = useState(false)
  const flags = useFeatureFlags()

  const triggerSnowyRun = () => {
    if (flags.snowyRunnerEnabled) {
      setSnowyRun(true)
      setTimeout(() => setSnowyRun(false), 4000)
    }
  }

  const isHalloween = flags.isHalloween
  const isThanksgiving = flags.isThanksgiving
  const isChristmas = flags.isChristmas
  const isValentine = flags.isValentine
  const isCNY = flags.isCNY
  const isPride = flags.isPride
  const isAprilFools = flags.isAprilFools
  const isBasketball = flags.isBasketball
  const isBirthday = flags.isBirthday

  const [aprilFoolsActive, setAprilFoolsActive] = useState(false)
  const triggerAprilFools = () => {
    if (isAprilFools && !aprilFoolsActive) setAprilFoolsActive(true)
  }
  const resetAprilFools = () => setAprilFoolsActive(false)

  const [basketballActive, setBasketballActive] = useState(false)
  const triggerBasketball = () => {
    if (isBasketball && !basketballActive) setBasketballActive(true)
  }
  const resetBasketball = () => setBasketballActive(false)

  return (
    <EasterEggContext.Provider
      value={{
        snowyRun,
        triggerSnowyRun,
        isHalloween,
        isThanksgiving,
        isChristmas,
        isValentine,
        isCNY,
        isPride,
        isAprilFools,
        aprilFoolsActive,
        triggerAprilFools,
        resetAprilFools,
        isBasketball,
        isBirthday,
        basketballActive,
        triggerBasketball,
        resetBasketball,
      }}
    >
      {children}
    </EasterEggContext.Provider>
  )
}
